import { Chip } from '@mui/material'
import { styles } from './styles'
import type { CertificateStatusProps } from './types'

export const CertificateStatus = ({ status, date }: CertificateStatusProps) => {
  if (status) {
    switch (status) {
      case 'ACTIVE':
        return (
          <Chip
            variant={'outlined'}
            size={'small'}
            color={'info'}
            label={`Действует до ${date}`}
            sx={{ backgroundColor: '#FFF', color: '#222' }}
          />
        )
      case 'INACTIVE':
        return (
          <Chip
            variant={'outlined'}
            size={'small'}
            color={'info'}
            label={`Действует до ${date}`}
            sx={{ backgroundColor: '#FFF', color: '#222' }}
          />
        )
      case 'BLOCKED_SOON':
        return (
          <Chip
            sx={styles.chip}
            variant={'outlined'}
            color="warning"
            label={`Истекает ${date}`}
          />
        )
      case 'BLOCKED':
        return (
          <Chip
            sx={styles.chip}
            variant={'outlined'}
            color="error"
            label={`Просрочен ${date}`}
          />
        )
      default:
        return (
          <Chip
            sx={styles.chip}
            variant={'outlined'}
            color="primary"
            label={'...'}
          />
        )
    }
  }
}
